export const meta = {
  id: 'M10',
  slug: 'registrar-sessao',
  title: 'Como registrar uma sessão de Mentoria',
  description: 'Registre o que foi compartilhado, suas anotações privadas e os Acordos definidos na sessão.',
  profile: 'mentor',
  category: 'mentorias',
  type: 'task',
  status: 'published',
  order: 310,
  keywords: ['mentoria', 'sessão', 'resumo compartilhado', 'nota privada', 'acordos', 'registro'],
  previous: 'M09',
  next: 'M11',
  related: ['A12', 'M11', 'M12'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como registrar uma sessão de Mentoria

O registro da sessão ajuda a transformar uma boa conversa em continuidade prática.

## Os três registros principais

- **Resumo compartilhado:** registra os principais pontos que o mentorado pode consultar depois.
- **Nota privada do Mentor:** serve ao seu trabalho interno e não é exibida ao Aluno / Mentorado.
- **Acordos:** registram compromissos e próximos passos definidos na sessão.

## Como registrar

<Steps>
  <Step title="Abra a sessão">
    Acesse a Mentoria correspondente ao mentorado e à data da conversa.
  </Step>
  <Step title="Registre o resumo compartilhado">
    Sintetize o tema principal, conclusões, orientações e foco para o próximo período.
  </Step>
  <Step title="Use a nota privada quando necessário">
    Registre apenas observações úteis para seu acompanhamento profissional.
  </Step>
  <Step title="Defina os Acordos">
    Transforme decisões da conversa em próximos passos claros.
  </Step>
</Steps>

<Callout type="important">
  A nota privada do Mentor nunca deve ser apresentada ao aluno como se fosse parte do resumo compartilhado. Quando algo precisa ser conhecido pelo mentorado, registre no espaço compartilhado apropriado.
</Callout>

## Depois da sessão

**Conversa → conclusão → Acordos → execução → acompanhamento.**

<HelpImage alt="Registro de uma sessão de Mentoria" pendingId="M10.1" />
<HelpImage alt="Resumo compartilhado da sessão" pendingId="M10.2" />
<HelpImage alt="Nota privada do Mentor" pendingId="M10.3" />
<HelpImage alt="Acordos registrados na Mentoria" pendingId="M10.4" />
